export default __webpack_public_path__ + "img/WB_NB_NOMA_WF.41fdc3df5bf699f670f0238ee26f87f5.jpg";